import router from "@/routes";
import axios from "axios";
/** Redirects the user to the login page and dispatches an error modal if they
 * do not have permission to access the requested resource and are also logged
 * in or only redirect them to the login page if they are not logged in.
 * @param e Error in an intercepted request. */

/** Environment route configs. */
let baseURL = window.location.origin;

if (process.env.NODE_ENV === "development") {
  const protocol = window.location.protocol;
  const hostname = window.location.hostname;
  const doubleSlash = "//";
  const port = ":8000";
  baseURL = protocol + doubleSlash + hostname + port;
}

/** Responsible to redirect student dev panel to adm dev panel or production student panel to production adm panel by clicking on menu. */
export const currentDomain = baseURL;
/** The axios instance containing the axios request config. */
const http = axios.create({
  withCredentials: true,
  baseURL,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
});

/** Response interceptor (intercepts all responses from any request made using axios in the app). */
http.interceptors.response.use(
  (response) => {
    return response;
  },
  async (e) => {
    await handleAccess(e);
    return Promise.reject(e);
  }
);

const handleAccess = async (e) => {
  const isUserNotAllowed: boolean = e?.response?.status === 403;

  if (isUserNotAllowed) {
    await router.push({ name: "home" });
  }

  return;
};

export default http;
